import React from "react";
import { Navigate } from "react-router-dom";
import { auth } from "../firebase";
import { useTasks } from 'components/Schedule/TaskContext';


const ProtectedRoute = ({ children }) => {
  const { user, loading } = useTasks();

  if (loading) {
    return <div>Loading...</div>; // Show a loading indicator or return null
  }

  if (!user) {
    return <Navigate to="/signin" />;
  }
  return children;
};
export default ProtectedRoute;
